'use client';

import clsx from 'clsx';
import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';

import styles from './Checkbox.module.scss';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: ReactNode;
  fullWidth?: boolean;
  /** Vertical alignment of the checkbox relative to the label text */
  align?: 'top' | 'center' | 'bottom';
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { label, fullWidth = false, align = 'center', className, id: providedId, disabled, ...props },
    ref
  ) => {
    const generatedId = useId();
    const id = providedId || generatedId;

    return (
      <label
        htmlFor={id}
        className={clsx(
          styles.wrapper,
          {
            [styles.fullWidth]: fullWidth,
            [styles.disabled]: disabled,
            [styles.alignTop]: align === 'top',
            [styles.alignBottom]: align === 'bottom',
          },
          className
        )}
      >
        <input ref={ref} id={id} type="checkbox" disabled={disabled} {...props} />
        <span className={styles.label}>{label}</span>
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';
